// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","checkbox":"Form_checkbox__RTwTj","textarea":"Form_textarea__TD5sz","ctaBtn":"Form_ctaBtn__C3RSM"};